
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karma",
      function () {
        return require("private-next-pages/karma/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karma"])
      });
    }
  